import TooltipCustom from 'ui/atoms/Tooltip/Tooltip';
import clsx from 'clsx';
import DialogSelectSessions from 'core/modules/components/dialogs/DialogSelectSessions/DialogSelectSessions';
import PropTypes from 'prop-types';
import React from 'react';
import { Tag } from 'ui';
import useSessionsTag from './useSessionsTag';

function SessionsTag({ sessions, courseGuid, lessonGuid, onSaveSessions, canEditSessions, lessonItemGuid }) {
  const { t, openDialog, parsedSessions, loading, onClickChangeSessions, onCloseDialog, onSuccessDialog } = useSessionsTag({
    sessions,
    onSaveSessions,
    lessonItemGuid,
    courseGuid,
  });

  return (
    <div className="sessions-tag" data-testid="sessions-tag">
      {parsedSessions?.length > 0 && (
        <button type="button" className={`button-accessibility-only ${clsx('sessions-tag__tag', { 'sessions-tag__tag--clickable': canEditSessions })}`} onClick={canEditSessions && onClickChangeSessions ? onClickChangeSessions : null} aria-label={
            canEditSessions ? `${parsedSessions[0]?.text + '. ' + t('common:Click to edit the assigned sessions')}` : t(`common:${parsedSessions[0]?.text}`)
          } aria-haspopup={canEditSessions ? 'dialog' : false} data-testid="first-session-tag"><Tag label={parsedSessions[0]?.text} leftIcon="calendar" /></button>
      )}

      {parsedSessions?.length > 1 && (
        <div className="sessions-tag__extra">
          <TooltipCustom title={parsedSessions.map((s) => s.text).join(', ')} placement="top" hasArrow={true}>
            <button type="button" className={`button-accessibility-only ${clsx('sessions-tag__additional-button', { 'sessions-tag__additional-button--clickable': canEditSessions })}`} onClick={canEditSessions && onClickChangeSessions ? onClickChangeSessions : null} aria-label={t('common:Additional sessions info', {
                count: parsedSessions.length - 1,
                sessions: parsedSessions
                  .slice(1)
                  .map((s) => s.text)
                  .join(', '),
              })} data-testid="additional-sessions-tag"><Tag label={`+${parsedSessions?.length - 1}`} /></button>
          </TooltipCustom>
        </div>
      )}

      {!!canEditSessions && !!openDialog && (
        <DialogSelectSessions
          open={openDialog}
          onClose={onCloseDialog}
          onSuccessDialog={onSuccessDialog}
          courseGuid={courseGuid}
          lessonGuid={lessonGuid}
          sessions={sessions}
          loading={loading}
        />
      )}
    </div>
  );
}

SessionsTag.propTypes = {
  sessions: PropTypes.arrayOf(
    PropTypes.shape({
      session_id: PropTypes.string,
      session_order: PropTypes.number,
    })
  ),
  lessonItemGuid: PropTypes.string,
  courseGuid: PropTypes.string,
  lessonGuid: PropTypes.string,
  onSaveSessions: PropTypes.func,
  canEditSessions: PropTypes.bool,
};

export default SessionsTag;
